const CombinedTitle = ({ intro, title, subtitle }) => {
  return (
    <div className="w-full py-10 px-2 md:px-4">
      <div className="flex flex-col lg:flex-row w-full gap-10">
        {/* Left side — intro + title */}

        <div>
          <p className="text-sm text-gray-500 uppercase">{intro}</p>
          <div className="flex justify-between items-center">
            <div className="w-full lg:w-3/5 text-left">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-semi-bold text-gray-900 mt-2 leading-tight">
                {title}
              </h2>
            </div>
            {/* Right side — subtitle (shown only on large devices) */}
            <div className="w-full lg:w-2/5 text-gray-500 text-justify text-lg hidden lg:block">
              {subtitle}
            </div>
          </div>
        </div>

        
      </div>
    </div>
  );
};

export default CombinedTitle;
